import { dateTime } from '@/_shared';

import type { SupportStatus } from './schemas/support-query-schema';
import { SupportTicketStatus } from './schemas/support-query-schema';

export const isTicketOpen = (status: SupportStatus): boolean => {
  return status !== SupportTicketStatus.CLOSED && status !== SupportTicketStatus.RESOLVED;
};

export const isTicketOverdue = (status: SupportStatus, dueBy: string | null): boolean => {
  return isTicketOpen(status) && !!dueBy && dateTime.isPast(dueBy);
};
